<template>
  <div class="ele-body">
    <el-card shadow="never">
      <!-- 搜索表单 -->
      <el-form :model="table.where" label-width="77px" class="ele-form-search" @keyup.enter.native="$refs.table.reload()" @submit.native.prevent>
        <el-row :gutter="15">
          <el-col :md="5" :sm="12">
            <el-form-item label="姓名:">
              <el-input v-model.trim="table.where.studentName" placeholder="请输入学生姓名" clearable />
            </el-form-item>
          </el-col>
          <el-col :md="5" :sm="12">
            <el-form-item label="手机号:">
              <el-input v-model.trim="table.where.mobile" placeholder="请输入手机号" clearable />
            </el-form-item>
          </el-col>
          <el-col :md="5" :sm="12">
            <el-form-item label="身份证号:">
              <el-input v-model.trim="table.where.idCardNum" placeholder="请输入身份证号" clearable />
            </el-form-item>
          </el-col>
          <el-col :md="6" :sm="12">
            <div class="ele-form-actions">
              <el-button type="primary" @click="$refs.table.reload()" icon="el-icon-search" class="ele-btn-icon">查询</el-button>
              <el-button @click="(table.where = {}) && $refs.table.reload()">重置</el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <!-- 操作按钮 -->
      <div class="ele-table-tool ele-table-tool-default">
        <el-button @click="showEdit = true" type="primary" icon="el-icon-plus" class="ele-btn-icon" size="small">添加录取结果</el-button>
        <el-button @click="remove()" type="danger" icon="el-icon-delete" class="ele-btn-icon" size="small">删除</el-button>
        <el-button @click="showImport = true" icon="el-icon-upload2" class="ele-btn-icon" size="small">导入录取结果</el-button>
      </div>
      <!-- 数据表格 -->
      <ele-data-table class="table" ref="table" :config="table" :choose.sync="choose" highlight-current-row>
        <template #default="{ index }">
          <el-table-column type="selection" width="45" align="center" fixed="left" />
          <el-table-column type="index" :index="index" width="45" align="center" fixed="left" show-overflow-tooltip />
          <el-table-column prop="schoolName" label="学校" sortable="custom" show-overflow-tooltip min-width="110" />
          <el-table-column prop="studentName" label="学生姓名" sortable="custom" show-overflow-tooltip min-width="110" />
          <el-table-column prop="mobile" label="手机号" sortable="custom" show-overflow-tooltip min-width="110" />
          <el-table-column prop="idCardNum" label="身份证号" sortable="custom" show-overflow-tooltip min-width="110" />
          <el-table-column prop="intakeTime" label="入学时间" sortable="custom" show-overflow-tooltip min-width="110" />
          <el-table-column prop="createTime" label="创建时间" sortable="custom" show-overflow-tooltip />
          <el-table-column label="操作" width="150px" align="center" :resizable="false">
            <template #default="{ row }">
              <el-link @click="edit(row)" icon="el-icon-edit" type="primary" :underline="false">修改</el-link>
              <el-popconfirm title="确定要删除此数据吗？" @onConfirm="remove(row)" class="ele-action">
                <el-link slot="reference" icon="el-icon-delete" type="danger" :underline="false">删除</el-link>
              </el-popconfirm>
            </template>
          </el-table-column>
        </template>
      </ele-data-table>
    </el-card>
    <!-- 添加或修改录取结果弹窗 -->
    <el-dialog
      :title="editForm.id ? '修改录取结果' : '添加录取结果'"
      :visible.sync="showEdit"
      width="350px"
      @closed="editForm = {}"
      :destroy-on-close="true"
      custom-class="ele-dialog-form"
      :lock-scroll="false"
    >
      <el-form :model="editForm" ref="editForm" :rules="editRules" label-width="85px">
        <el-form-item label="学生姓名:" prop="studentName">
          <el-input v-model="editForm.studentName" placeholder="请输入学生姓名" clearable />
        </el-form-item>
        <el-form-item label="手机号:" prop="mobile">
          <el-input v-model="editForm.mobile" placeholder="请输入手机号" clearable />
        </el-form-item>
        <el-form-item label="学校名称:" prop="schoolName">
          <el-input v-model="editForm.schoolName" placeholder="请输入学校名称" clearable />
        </el-form-item>
        <el-form-item label="身份证号:" prop="idCardNum">
          <el-input v-model="editForm.idCardNum" placeholder="请输入身份证号" clearable />
        </el-form-item>
        <el-form-item label="入学时间:">
          <el-date-picker v-model="editForm.intakeTime" value-format="yyyy-MM-dd" type="date" placeholder="选择日期" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showEdit = false">取 消</el-button>
        <el-button type="primary" @click="save(editForm.id)">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 导入录取结果 -->
    <el-dialog title="导入录取结果" :visible.sync="showImport" width="440px" :destroy-on-close="true" :lock-scroll="false">
      <el-upload
        v-loading="uploadLoading"
        :action="$http.defaults.baseURL + '/admission/import'"
        accept=".xls,.xlsx"
        :headers="$http.defaults.headers.common"
        :before-upload="() => (uploadLoading = true)"
        class="ele-block"
        :on-success="uploadInfoSuccess"
        :on-error="() => (uploadLoading = false)"
        :show-file-list="false"
        drag
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或 <em>点击上传</em></div>
        <div class="el-upload__tip ele-text-center" slot="tip">
          只能上传xls、xlsx文件，
          <el-link type="primary" :underline="false" :href="importTplUrl" download style="vertical-align: baseline">下载模板 </el-link>
        </div>
      </el-upload>
    </el-dialog>
  </div>
</template>

<script>
  import { delAdmissionResult, saveAdmissionResult } from '../../config/api';

  export default {
    name: 'List',
    data() {
      return {
        table: {
          // 表格配置
          url: '/admission/getList',
          where: {},
          parseData(res) {
            if (res.resCode == 200) res.code = 0;
            res.count = res.data.total;
            res.data = res.data.records;
            return res;
          },
        },
        choose: [],
        showEdit: false, // 是否显示表单弹窗
        editForm: {}, // 表单数据
        editRules: {
          // 表单验证规则
          idCardNum: [{ required: true, message: '请输入身份证号', trigger: 'blur' }],
          mobile: [{ required: true, message: '请输入手机号', trigger: 'blur' }],
          schoolName: [{ required: true, message: '请输入学校名称', trigger: 'blur' }],
          studentName: [{ required: true, message: '请输入学生姓名', trigger: 'blur' }],
        },
        showImport: false,
        uploadLoading: false,
        importTplUrl: 'https://hdsys.oss-cn-beijing.aliyuncs.com/hdjxt/template/1723077772056/录取结果导入模板.xlsx',
      };
    },
    methods: {
      /* 显示编辑 */
      edit(row) {
        this.editForm = Object.assign({}, row);
        this.showEdit = true;
      },
      /* 保存编辑 */
      save(userId) {
        this.$refs['editForm'].validate((valid) => {
          if (valid) {
            const loading = this.$loading({ lock: true });
            let formData = new FormData();
            for (let key in this.editForm) {
              if (this.editForm[key] !== null && this.editForm[key] !== undefined) {
                formData.append(key, this.editForm[key]);
              }
            }
            if (userId == undefined) {
              saveAdmissionResult(formData)
                .then((res) => {
                  loading.close();
                  if (res.data.resCode == 200) {
                    this.showEdit = false;
                    this.$message({ type: 'success', message: res.data.resMsg });
                    this.$refs.table.reload();
                  } else {
                    this.$message.error(res.data.resMsg);
                  }
                })
                .catch((e) => {
                  loading.close();
                  this.$message.error(e.message);
                });
            } else {
              saveAdmissionResult(formData)
                .then((res) => {
                  loading.close();
                  if (res.data.resCode == 200) {
                    this.showEdit = false;
                    this.$message({ type: 'success', message: res.data.resMsg });
                    this.$refs.table.reload();
                  } else {
                    this.$message.error(res.data.resMsg);
                  }
                })
                .catch((e) => {
                  loading.close();
                  this.$message.error(e.message);
                });
            }
          } else {
            return false;
          }
        });
      },
      // 删除录取结果
      remove(row) {
        if (!row) {
          if (this.choose.length === 0) return this.$message.error('请至少选择一条数据');
          let ids = this.choose.map((d) => d.id);
          let formData = new FormData();
          formData.append('ids', ids);
          this.$confirm('确定要移除选中的录取结果吗?', '提示', {
            type: 'warning',
          }).then(() => {
            const loading = this.$loading({ lock: true });
            delAdmissionResult(formData).then((res) => {
              loading.close();
              if (res.data.resCode == 200) {
                this.$message({ type: 'success', message: res.data.resMsg });
                this.$refs.table.reload();
              } else {
                this.$message.error(res.data.resMsg);
              }
            });
          });
        } else {
          const loading = this.$loading({ lock: true });
          let formData = new FormData();
          formData.append('ids', row.id);
          delAdmissionResult(formData).then((res) => {
            loading.close();
            if (res.data.resCode == 200) {
              this.$message({ type: 'success', message: res.data.resMsg });
              this.$refs.table.reload();
            } else {
              this.$message.error(res.data.resMsg);
            }
          });
        }
      },
      // 导入录取结果
      uploadInfoSuccess(res) {
        this.uploadLoading = false;
        if (res.resCode == '200') {
          this.showImport = false;
          this.$message({
            type: 'success',
            message: '导入成功',
            duration: 3000,
          });
          if (res.data != []) {
            let mesaage = '';
            res.data.forEach((item, index) => {
              mesaage += '<div>' + (index + 1) + '、' + item + '</div>';
            });
            this.$notify({
              title: '警告',
              customClass: 'notifyClass',
              dangerouslyUseHTMLString: true,
              message: mesaage,
              type: 'warning',
              duration: 0,
            });
          }
          this.$refs.table.reload();
        } else {
          this.$message.error(res.resMsg);
        }
      },
    },
  };
</script>

<style>
  .ele-block >>> .el-upload,
  .ele-block >>> .el-upload-dragger {
    width: 100%;
  }
  .table {
    height: calc(100vh - 262px);
  }
  .ele-block {
    display: flex !important;
    flex-flow: column !important;
    align-items: center !important;
  }
  .notifyClass {
    width: 400px !important;
  }
</style>
